/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { userDonationModelPagedResultSchema } from "../userDonationModelPagedResultSchema.ts";
import { z } from "zod";

export const getApiDonationsByUserQueryParamsSchema = z.object({
    "StartDate": z.string().datetime({ offset: true }).describe("Фильтр по дате (Начальная дата)").optional(),
"EndDate": z.string().datetime({ offset: true }).describe("Фильтр по дате (Конечная дата)").optional(),
"SortByAmount": z.boolean().describe("Сортировка по сумме платежа").optional(),
"SortByAmountDesc": z.boolean().describe("Сортировка по сумме платежа в обратном порядке").optional(),
"SortByName": z.boolean().describe("Сортировка по никнейму").optional(),
"SortByNameDesc": z.boolean().describe("Сортировка по никнейму в обратном порядке").optional(),
"SortByDate": z.boolean().describe("Сортировка по дате платежа").optional(),
"SortByDateDesc": z.boolean().describe("Сортировка по дате платежа в обратном порядке").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Успешно
 */
export const getApiDonationsByUser200Schema = z.lazy(() => userDonationModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiDonationsByUser400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiDonationsByUser401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiDonationsByUser403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiDonationsByUser500Schema = z.lazy(() => badResponseModelSchema)

export const getApiDonationsByUserQueryResponseSchema = z.lazy(() => getApiDonationsByUser200Schema)